import { useState, useEffect } from 'react';

import { useFetchRetrieveAccounts } from '@services';

interface AccountSelectorPlaceholderHelper {
	isLoading: boolean;
}

export const useAccountSelectorPlaceholderHelper = (): AccountSelectorPlaceholderHelper => {
	const { success } = useFetchRetrieveAccounts();
	const [isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		if (success !== undefined) {
			setIsLoading(false);
		}
	}, [success]);

	return {
		isLoading,
	};
};
